function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const updateLocalizations = _async(function (context, client, instance, updates) {
  return _await(getPropertyLocales(client), function (locales) {
    const businessLocalizer = BusinessLocalizerFactory(locales);
    const businessLocalizations = businessLocalizer.getLocalizations(updates);
    const {
      businessId
    } = context.serialize();
    const businessRepo = client.businesses.for(businessId);
    return Promise.all(businessLocalizations.map(({
      locale,
      content
    }) => businessRepo.setLocalization({
      locale,
      content
    })));
  });
});

const {
  Business
} = require('../entities');

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

const AccessContext = require('./contexts/access-context');

const BusinessCategoriesRepo = require('./business-categories-repo');

const getPropertyLocales = require('../utils/get-property-locales');

const BusinessLocalizerFactory = require('../entities/business-localizer'); // TODO: Replace this with a pipeline instance (see Offer and Collection)


const updateBusiness = _async(function (context
/*: AccessContext*/
, client
/*: ApiClient*/
, instance
/*: Business*/
, updates
/*: Business | Object*/
, parse
/*: Object => Business*/
, serialize
/*: Business => Object*/
, fields
/*: Array<string>*/
)
/*: Promise<Business>*/
{
  const {
    businessId
  } = context.serialize();
  return _await(getPropertyLocales(client), function (locales) {
    const businessLocalizer = BusinessLocalizerFactory(locales);
    const businessUpdates = businessLocalizer.applyDefaultLocalizations(updates); // Do not diff because it loses images
    // TODO: Figure out how to safely diff without losing images

    const req = new client.Request(`/businesses/${businessId}`, businessUpdates, fields);
    req.parse = parse;
    req.serialize = serialize;
    return client.patch(req);
  });
});

const updateSlugStep = _async(function (context
/*: AccessContext*/
, client
/*: ApiClient*/
, instance
/*: Business*/
, updates
/*: Business | Object*/
) {
  const existingSlug = instance.slug;
  const newSlug = updates.slug;
  if (newSlug && newSlug === existingSlug) return existingSlug;
  const {
    businessId
  } = context.serialize();
  return client.businesses.for(businessId).updateSlug(newSlug || instance.name);
});

const updateBusinessCategoriesStep = (context
/*: AccessContext*/
, client
/*: ApiClient*/
, business, categories, updatedCategories) =>
/*: Promise<Business>*/
{
  const catIds = categories.map(c => c.id);
  const updatedCatIds = updatedCategories.map(c => c.id);
  const categoriesRepo = new BusinessCategoriesRepo(client, context);
  return categoriesRepo.reconcile(catIds, updatedCatIds).then(() => business);
};

const businessUpdatePipeline = _async(function (context
/*: AccessContext*/
, client
/*: ApiClient*/
, instance
/*: Business*/
, updates
/*: Business | Object*/
, parse
/*: Object => Business*/
, serialize
/*: Business => Object*/
, fields
/*: Array<string>*/
) {
  const updatesCategories = updates.categories;
  return _await(updateBusiness(context, client, instance, updates, parse, serialize, fields), function (updatedBusiness) {
    return _await(updateLocalizations(context, client, instance, updates), function () {
      return _await(updateSlugStep(context, client, updatedBusiness, updates), function () {
        return updatesCategories ? updateBusinessCategoriesStep(context, client, updatedBusiness, instance.categories, updates.categories) : updatedBusiness;
      });
    });
  });
});

module.exports = businessUpdatePipeline;